define('OutSystems/ReactView/HtmlTags',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HtmlTags = void 0;
    var HtmlTags;
    (function (HtmlTags) {
        HtmlTags["a"] = "a";
        HtmlTags["button"] = "button";
        HtmlTags["div"] = "div";
        HtmlTags["form"] = "form";
        HtmlTags["i"] = "i";
        HtmlTags["img"] = "img";
        HtmlTags["input"] = "input";
        HtmlTags["label"] = "label";
        HtmlTags["span"] = "span";
        HtmlTags["textarea"] = "textarea";
    })(HtmlTags || (exports.HtmlTags = HtmlTags = {}));
});
//# sourceMappingURL=HtmlTags.js.map;
